import config from '../../../config/config-default';

import { toggleButtons } from '../submit/submit';

const updatePrice = (charge, extraDays, surcharge, weight) => {
	const formSurcharge = document.getElementById('surcharge');
	const formTotal = document.getElementById('total');
	const infoCharge = document.getElementById('info-charge');
	const infoExtraDays = document.getElementById('info-extra-days');
	const infoSurcharge = document.getElementById('info-surcharge');
	const infoTotal = document.getElementById('info-total');
	const weightDisplay = document.getElementById('weight-display-4');
	const weightRate = document.getElementById('weight-rate-4');

	const total = charge + extraDays + surcharge;

	formSurcharge.value = surcharge.toFixed(2);
	formTotal.value = total.toFixed(2);

	infoCharge.textContent = charge.toFixed(2);
	infoExtraDays.textContent = extraDays.toFixed(2);
	infoSurcharge.textContent = surcharge.toFixed(2);
	infoTotal.textContent = total.toFixed(2);

	weightDisplay.textContent = weight;
	weightRate.textContent = (
		window[config.globalScope].options.costs.per_100kg_over || 0
	).toFixed(2);
};

const calculatePrice = (includeSurcharge = false) => {
	const formCharge = document.getElementById('charge');
	const formExtraDays = document.getElementById('extra-days');
	const formWeight = document.getElementById('weight');

	const charge = formCharge.value > 0 ? +formCharge.value : 0;
	const extraDays = formExtraDays.value > 0 ? +formExtraDays.value : 0;
	const weight = formWeight.value > 0 ? +formWeight.value : 0;

	const subtotal = charge + extraDays;
	const surcharge = includeSurcharge ? subtotal * 0.03 : 0;

	updatePrice(charge, extraDays, surcharge, weight);
};

const initStep4 = () => {
	calculatePrice();

	const paymentMethods = document.querySelectorAll(
		'input[name="payment_method"]',
	);
	const directDepositInfo = document.getElementById('direct-deposit-info');
	// const chequeInfo = document.getElementById('cheque-info');

	paymentMethods.forEach((radio) =>
		radio.addEventListener('change', () => {
			if (radio.value === 'Direct Deposit') {
				directDepositInfo.style.display = 'block';
			} else {
				directDepositInfo.style.display = 'none';
			}
			/* if (radio.value === 'Cheque') {
				chequeInfo.style.display = 'block';
			} else {
				chequeInfo.style.display = 'none';
			} */
			if (['Credit Card', 'PayPal'].includes(radio.value)) {
				calculatePrice(true);
			} else {
				calculatePrice();
			}
			toggleButtons(false);
		}),
	);
};

export default initStep4;
